import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { HomeDailyLessonPopoverArrowIcon } from '../atoms/icons/home_daily_lesson_popover_arrow_icon';
import { Colors } from '../styles/variables';
export const HomeDailyLessonDiagnosisPopover = ({ top, left, arrowLeft, isClosing, positionAbsolute, onExited, onClick, classObject, }) => {
    const onClickPopoverPanel = (event) => {
        event.stopPropagation();
    };
    const onAnimationEnd = (event) => {
        if (isClosing && event.target === event.currentTarget) {
            onExited === null || onExited === void 0 ? void 0 : onExited();
        }
    };
    return (React.createElement("div", { className: css(styles.container, positionAbsolute && styles.containerAbsolute, isClosing && styles.containerClosing, classObject), style: { top, left, transformOrigin: `${arrowLeft + 34}px 0` }, onAnimationEnd: onAnimationEnd },
        React.createElement("div", { className: css(styles.arrow), style: { left: arrowLeft } },
            React.createElement(HomeDailyLessonPopoverArrowIcon, { color: Colors.BlueLighter })),
        React.createElement("div", { className: css(styles.panel), onClick: onClickPopoverPanel },
            React.createElement("img", { src: "/assets/images/course/daily_lesson_diagnosis_lessons.png", alt: "", className: css(styles.illustration) }),
            React.createElement("p", { className: css(styles.description) }, "AI\u304C\u3042\u306A\u305F\u306B\u3074\u3063\u305F\u308A\u306E\u30EC\u30C3\u30B9\u30F3\u3092\u63D0\u6848\u2728"),
            React.createElement("div", { className: css(styles.button), onClick: onClick }, "AI\u8A3A\u65AD\u30B9\u30BF\u30FC\u30C8\uFF01"))));
};
const styles = StyleSheet.create({
    container: {
        position: 'fixed',
        width: 340,
        minWidth: 340,
        pointerEvents: 'none',
        filter: 'drop-shadow(rgba(118, 137, 162, 0.15) 0px 0px 20px)',
        animationName: {
            '0%': { opacity: 0, transform: 'scale(0.5)' },
            '55%': { opacity: 1, transform: 'scale(1.04)' },
            '100%': { opacity: 1, transform: 'scale(1)' },
        },
        animationDuration: '0.4s',
        animationTimingFunction: 'ease-out',
        animationFillMode: 'both',
    },
    containerAbsolute: {
        position: 'absolute',
    },
    containerClosing: {
        animationName: {
            '0%': { opacity: 1, transform: 'scale(1)' },
            '100%': { opacity: 0, transform: 'scale(0.5)' },
        },
        animationDuration: '0.2s',
        animationTimingFunction: 'ease-in',
    },
    arrow: {
        position: 'absolute',
        top: 2,
        width: 68,
        height: 36,
        lineHeight: 0,
        pointerEvents: 'none',
    },
    panel: {
        position: 'relative',
        marginTop: 18,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 8,
        padding: 16,
        borderRadius: 20,
        background: Colors.BackgroundAi,
        pointerEvents: 'auto',
    },
    illustration: {
        width: 219,
        height: 'auto',
        display: 'block',
    },
    description: {
        margin: 0,
        fontSize: 14,
        fontWeight: 500,
        lineHeight: 1.4,
        letterSpacing: 0.56,
        textAlign: 'center',
        color: Colors.TextDark,
    },
    button: {
        alignSelf: 'stretch',
        fontSize: 16,
        fontWeight: 'bold',
        lineHeight: 1.6,
        letterSpacing: 1.28,
        textAlign: 'center',
        color: Colors.White,
        padding: '12px 16px',
        borderRadius: 24,
        background: Colors.BackgroundAiRainbowB,
        boxShadow: '0 2px 10px 0 rgba(0, 89, 98, 0.30)',
        cursor: 'pointer',
    },
});
